var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$i18n.locale === 'en')?_c('TFUnderGrad2024EN'):_vm._e(),(_vm.$i18n.locale === 'zh')?_c('TFUnderGrad2024CN'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }